import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { productDetailPath } from "../../constants/routes";
import { useLocalizedProduct } from "../../hooks/useLocalizedProduct";
import { useCartStore } from "../../store/cartStore";
import "../common/HeroSection.css";
import "../landing/LandingProductCard.css";
import "./ProductCard.css";

function getDisplayCategory(categories = []) {
  return categories.find((category) => category.slug !== "uncategorized");
}

function ProductCard({ product, showAddToCart = false }) {
  const { t } = useTranslation();
  const localizedProduct = useLocalizedProduct(product);
  const addItem = useCartStore((state) => state.addItem);
  const [added, setAdded] = useState(false);

  if (!localizedProduct) return null;

  const detailPath = productDetailPath(localizedProduct.slug);
  const category = getDisplayCategory(localizedProduct.categories);
  const badgeLabel = category?.name || t("Product");

  const handleAddToCart = (event) => {
    event.preventDefault();
    event.stopPropagation();
    addItem(localizedProduct, 1);
    setAdded(true);
    window.setTimeout(() => setAdded(false), 2000);
  };

  return (
    <article className="landing-product-card caf-product-card group">
      <Link to={detailPath} className="caf-product-card__detail-link">
        <div className="landing-product-card__media">
          {localizedProduct.image ? (
            <img
              src={localizedProduct.image}
              alt={localizedProduct.name}
              className="landing-product-card__image"
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="landing-product-card__placeholder" aria-hidden="true" />
          )}
          <span className="landing-product-card__badge">{badgeLabel}</span>
        </div>

        <div className="landing-product-card__content">
          <h3 className="landing-product-card__title">{localizedProduct.name}</h3>
          {localizedProduct.shortDescription ? (
            <p className="landing-product-card__excerpt">{localizedProduct.shortDescription}</p>
          ) : null}
        </div>
      </Link>

      <div className="caf-product-card__footer-panel">
        <div className="caf-product-card__price-row">
          {localizedProduct.formattedPrice ? (
            <>
              <span className="caf-product-card__price-label">{t("Price")}</span>
              <span className="caf-product-card__price" dir="ltr">
                {localizedProduct.formattedPrice}
              </span>
            </>
          ) : (
            <span className="caf-product-card__price caf-product-card__price--quote">
              {t("Request a Quote")}
            </span>
          )}
        </div>

        {showAddToCart ? (
          <button
            type="button"
            className="hero-btn hero-btn--primary caf-product-card__cta-btn"
            onClick={handleAddToCart}
            aria-label={t("Add to cart")}
          >
            <span className="hero-btn__label">
              {added ? t("Added to cart") : t("Add to cart")}
            </span>
            <span className="hero-btn__icon-wrap" aria-hidden="true">
              <FaArrowLeft className="hero-btn__icon" />
            </span>
          </button>
        ) : (
          <Link
            to={detailPath}
            className="hero-btn hero-btn--primary caf-product-card__cta-btn"
          >
            <span className="hero-btn__label">{t("View product")}</span>
            <span className="hero-btn__icon-wrap" aria-hidden="true">
              <FaArrowLeft className="hero-btn__icon" />
            </span>
          </Link>
        )}
      </div>
    </article>
  );
}

export default ProductCard;
